import { ServerFile } from "./ProjectsFiles";

export enum SeverityLevel {
  Success = "Success",
  Low = "Low",
  Medium = "Medium",
  High = "High",
  Critical = "Critical",
}

export enum SeverityRank {
  Success = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  Critical = 4,
}

export const statusPillColorMap: Record<SeverityLevel, string> = {
  [SeverityLevel.Success]: "text-green-500 bg-green-100 border-green-400",
  [SeverityLevel.Low]: "text-orange-500 bg-orange-100 border-orange-400",
  [SeverityLevel.Medium]: "text-orange-500 bg-orange-100 border-orange-400",
  [SeverityLevel.High]: "text-red-500 bg-red-100 border-red-400",
  [SeverityLevel.Critical]: "text-red-500 bg-red-100 border-red-400",
};

export const sectionTitleColorMap: Record<SeverityLevel, string> = {
  [SeverityLevel.Success]: "text-green-600",
  [SeverityLevel.Low]: "text-orange-500 ",
  [SeverityLevel.Medium]: "text-orange-500 ",
  [SeverityLevel.High]: "text-red-500 ",
  [SeverityLevel.Critical]: "text-red-500 ",
};

export const sectionIconMap: Record<SeverityLevel, string> = {
  [SeverityLevel.Success]: "/status/checkmark.svg",
  [SeverityLevel.Low]: "/status/warning.svg",
  [SeverityLevel.Medium]: "/status/warning.svg",
  [SeverityLevel.High]: "/status/error.svg",
  [SeverityLevel.Critical]: "/status/error.svg",
};

export interface AnomalyMeta {
  totalCount: number;
  highestSeverity: SeverityLevel | null;
}

export type EntryType = "error" | "warning";

export interface EvidenceDetails {
  [key: string]: Record<string, any>;
}

type AnomalyStatus = "Ignored" | "Resolved" | "Pending";

export interface AnomalyFinding {
  id: string;
  affected_cells: AffectedCell[];
  file_id: string;
  title: string;
  description: string;
  severity: SeverityLevel;
  category: string;
  level: string;
  columns_affected: Record<string, string[]>;
  evidence_details: EvidenceDetails;
  required_action: string;
  detected_at: string; // ISO timestamp
  resolution_status: AnomalyStatus;
}

export interface AffectedCell {
  column_name: string;
  ranges: [number, number][];
  sheet_name: string;
  total_affected: number;
}

export interface AnomalyData {
  findings: AnomalyFinding[];
  total_count: number;
}

export type Entry = {
  file: ServerFile;
  anomaly_data: AnomalyData;
};

export type FileStatusPopupProps = {
  data: Entry;
  onClose: () => void;
};
